import * as styleVars from '@styles/variables.scss';
import * as colors from '@colors';

const vars = { colors };

Object.keys(styleVars).forEach(key => {
  const num = parseInt(styleVars[key]);
  vars[key] = !isNaN(num) ? num : styleVars[key];
});

export default function useStyleVars() {
  return vars;
}
